import { connect } from 'react-redux'
import Step3Confirm from './Step3Confirm'

import { updateNewTransferCreation } from '../../../redux/actions/transfers_2'

const mapStateToProps = state => {
    return {
        app_state: state.app_state,
        transfers_2: state.transfers_2,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateNewTransferCreation: (key, value) => {
            dispatch(updateNewTransferCreation(key, value))
        },
    }
}

const Step3ConfirmContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Step3Confirm)

export default Step3ConfirmContainer
